//
// Copyright 2024 DXOS.org
//

export const defaultColSize = 180;
export const defaultRowSize = 30;
